import { FC, ReactNode, createContext, useContext, useState } from 'react';

const useHomeContextStore = () => {
  const [selectedTagId, setSelectedTagId] = useState<number>(0);

  return {
    selectedTagId,
    setSelectedTagId,
  };
};

type HomeContextType = ReturnType<typeof useHomeContextStore>;

const HomeContext = createContext<HomeContextType | null>(null);

type HomeContextProviderProps = {
  children: ReactNode;
};
export const HomeContextProvider: FC<HomeContextProviderProps> = ({ children }) => {
  return <HomeContext.Provider value={useHomeContextStore()}>{children}</HomeContext.Provider>;
};

export const useHomeContext = () => {
  const homeCtx = useContext(HomeContext);

  if (homeCtx === null) {
    throw new Error('HomeContext is null');
  }

  return homeCtx;
};
